import { useRegisterSW } from "virtual:pwa-register/vue";
import { useLogger } from "@/composables/logger";
import { Plugin } from "vue";

const { info, error: logError } = useLogger("REGISTER_SERVICE_WORKER");
export default {
  install() {
    info("trying to register sw");
    useRegisterSW({
      onNeedRefresh() {
        info("onNeedRefresh");
      },
      onOfflineReady() {
        info("onOfflineReady");
      },
      onRegisterError(error) {
        logError("onRegisterError", { error });
      },
      onRegistered(registration) {
        info("onRegistered", { registration });
      }
    });
  }
} as Plugin;
